import RoomList from './List'

export default function RoomsListIndex() {
  return <RoomList />
}